import Searchicon from 'icons/searchicon'
import React from 'react'
import { useIntl } from 'react-intl'

function SearchList({ search }) {
  const { formatMessage } = useIntl()
  return (
    <div class='tw-ml-[10px] tw-w-full md:tw-w-[250px] tw-flex tw-py-[5px] tw-rounded-[8px] tw-bg-gray-100 tw-px-[10px] tw-gap-[10px] tw-items-center tw-shrink-0 tw-mr-2'>
      <Searchicon />
      <input
        class='tw-bg-gray-100 tw-w-full tw-border-none placeholder:tw-text-slate-300 tw-font-sm focus:tw-ring-0 tw-p-0'
        placeholder={formatMessage({ id: 'Start typing to search' })}
        type='text'
        onChange={search}
      />
    </div>
  )
}

export default SearchList
